import LegalLayout, { LegalSection, LegalList } from "@/pages/legal/LegalLayout";
import { COMPANY } from "@/lib/company";

export default function CookiePolicyPage() {
  return (
    <LegalLayout
      title="Cookie Policy"
      subtitle="Informativa sull'uso dei cookie e delle tecnologie assimilate, resa ai sensi dell'art. 122 del D.Lgs. 196/2003 e delle Linee guida del Garante per la protezione dei dati personali del 10 giugno 2021."
      updated="giugno 2026"
      testId="cookie-policy-page"
    >
      <LegalSection number="1" title="Cosa sono i cookie">
        <p>
          I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo dell'utente,
          dove vengono memorizzati per essere ritrasmessi agli stessi siti in occasione di visite
          successive. Tecnologie assimilate (es. local storage) perseguono finalità analoghe. In base
          alla finalità, si distinguono <strong>cookie tecnici</strong> (necessari al funzionamento del
          sito, per i quali non è richiesto il consenso) e <strong>cookie di profilazione</strong>{" "}
          (volti a tracciare la navigazione e creare profili dell'utente, per i quali è richiesto il
          consenso preventivo).
        </p>
      </LegalSection>

      <LegalSection number="2" title="Cookie utilizzati da questo sito">
        <p>
          Il sito {COMPANY.site} utilizza esclusivamente <strong>cookie tecnici strettamente
          necessari</strong> al corretto funzionamento e alla sicurezza del sito (es. bilanciamento del
          carico e distribuzione dei contenuti da parte dell'infrastruttura di hosting). In particolare:
        </p>
        <LegalList
          items={[
            "non vengono utilizzati cookie di profilazione, né propri né di terze parti;",
            "non vengono utilizzati strumenti di analisi statistica (analytics) né pixel di tracciamento;",
            "non vengono utilizzati cookie per finalità pubblicitarie o di marketing.",
          ]}
        />
        <p>
          Poiché il sito utilizza soltanto cookie tecnici, ai sensi delle Linee guida del Garante del 10
          giugno 2021 <strong>non è richiesto il banner di acquisizione del consenso</strong>: la
          presente informativa è sufficiente.
        </p>
      </LegalSection>

      <LegalSection number="3" title="Collegamenti a servizi di terze parti">
        <p>
          Il sito contiene pulsanti e collegamenti che aprono l'applicazione o il sito{" "}
          <strong>WhatsApp</strong> (WhatsApp Ireland Limited, gruppo Meta) per consentire all'utente di
          contattare {COMPANY.brand}. Il semplice caricamento delle pagine di questo sito non comporta
          l'installazione di cookie di WhatsApp/Meta; solo quando l'utente sceglie di aprire WhatsApp,
          la navigazione prosegue sulla piattaforma del terzo, che tratta i dati secondo le proprie
          policy:
        </p>
        <LegalList
          items={[
            <span key="1">
              Informativa privacy WhatsApp:{" "}
              <a
                href="https://www.whatsapp.com/legal/privacy-policy-eea"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#5B2C91] underline underline-offset-2"
              >
                whatsapp.com/legal/privacy-policy-eea
              </a>
            </span>,
            <span key="2">
              Cookie policy Meta:{" "}
              <a
                href="https://www.facebook.com/privacy/policies/cookies"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#5B2C91] underline underline-offset-2"
              >
                facebook.com/privacy/policies/cookies
              </a>
            </span>,
          ]}
        />
      </LegalSection>

      <LegalSection number="4" title="Gestione dei cookie tramite browser">
        <p>
          L'utente può gestire o eliminare i cookie attraverso le impostazioni del proprio browser.
          Disabilitare i cookie tecnici potrebbe compromettere il corretto funzionamento del sito.
          Istruzioni per i browser più diffusi:
        </p>
        <LegalList
          items={[
            <a key="1" href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-[#5B2C91] underline underline-offset-2">Google Chrome</a>,
            <a key="2" href="https://support.mozilla.org/it/kb/protezione-antitracciamento-avanzata-firefox-desktop" target="_blank" rel="noopener noreferrer" className="text-[#5B2C91] underline underline-offset-2">Mozilla Firefox</a>,
            <a key="3" href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-[#5B2C91] underline underline-offset-2">Apple Safari</a>,
            <a key="4" href="https://support.microsoft.com/it-it/microsoft-edge/eliminare-i-cookie-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" className="text-[#5B2C91] underline underline-offset-2">Microsoft Edge</a>,
          ]}
        />
      </LegalSection>

      <LegalSection number="5" title="Titolare del trattamento e aggiornamenti">
        <p>
          Il Titolare del trattamento è {COMPANY.name}, {COMPANY.address}, P.IVA {COMPANY.vat}. Per
          maggiori informazioni sul trattamento dei dati personali si rinvia alla{" "}
          <a href="/privacy-policy" className="text-[#5B2C91] underline underline-offset-2">Privacy Policy</a>.
          La presente Cookie Policy può essere aggiornata in caso di modifiche ai cookie utilizzati dal
          sito; eventuali variazioni saranno pubblicate su questa pagina. Qualora in futuro venissero
          introdotti cookie diversi da quelli tecnici, sarà preventivamente implementato un banner di
          acquisizione del consenso conforme alla normativa.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
